module.exports = __webpack_public_path__ + "img/header-diamondJewelryRedgold@2x.c08d948.jpg";